<template>
  <div class="confetti-breadcrumbs">
    <slot />
    <div class="breadcrumbs-current-route">
      {{ currentRoute }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfettiBreadcrumbs",
  props: {
    currentRoute: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/breakpoints";
@import "confetti/scss/variables/colors";
@import "confetti/scss/variables/typography";
@import "confetti/scss/components/confetti-breadcrumbs";
</style>
